module.exports = __webpack_public_path__ + "img/1-on.875c0af4.png";